import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { pageIndicator } from "../apollo";
import {
  ComponentTabLink,
  ITabLink,
  ITabTitle,
  PageType,
} from "../components/component-tab";
import { AsideAdminComponent } from "../layout/aside-admin";
import { FormError2 } from "../components/form-error";
import { Button } from "../components/button";
import { useCrCorporation } from "../hooks/useCrCorporation";
import { usePrompt } from "../constants/function";
import {
  CrCorporationInput,
  CrCorporationMutation,
  ListCorporationSelectQuery,
} from "../generated/graphql";
import { useListLinkServiceSelect } from "../hooks/useListLinkServiceSelect";
import {
  CouponScope,
  CouponScopeOption,
  CouponStatusOption,
  CouponStatus,
} from "../constants/enum";
import { useListCorporationSelect } from "../hooks/useListCorprationSelect";
import Select from "react-select";
import {
  CrCouponInput,
  CrCouponMutation,
  CrCouponVariables,
  useCrCoupon,
} from "../hooks/useCrCoupon";
export const AdminCrCoupon = () => {
  const [out, setOut] = useState<boolean>(true);
  const [scopeOption, setScopeOption] = useState<string>("LINK_SERVICE");
  const { confirmNavigation, showPrompt, cancelNavigation } = usePrompt(out);
  // 서비스 지역 불러오기
  const [
    listLinkServiceSelect,
    { data: linkservice },
  ] = useListLinkServiceSelect();
  // 매장 불러오기
  const onListCorporationSelect = (data: ListCorporationSelectQuery) => {};
  const [
    listCorporationSelect,
    { data: corporationSelect },
  ] = useListCorporationSelect(onListCorporationSelect);

  useEffect(() => {
    if (showPrompt) {
      if (
        window.confirm("변경사항이 저장 되지 않았습니다. 이동하시겠습니까?")
      ) {
        confirmNavigation();
      } else {
        cancelNavigation();
      }
    }
    pageIndicator("coupon");
    if (!out) {
      window.location.href = `/coupon`;
    }
  }, [showPrompt, out]);

  const {
    getValues,
    setValue,
    setFocus,
    register,
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm<CrCouponInput>({ mode: "all" });

  const onCrCouponComplete = async (data: CrCouponMutation) => {
    const {
      crCoupon: { ok, err },
    } = data;
    console.log(data);
    if (ok) {
      alert("저장되었습니다");
      setOut(false);
    } else {
      alert(err);
    }
  };

  const [CrCoupon, { loading }] = useCrCoupon(onCrCouponComplete);
  const onSubmit = () => {
    if (!loading) {
      const {
        name,
        scope,
        status,
        code,
        validFrom,
        validUntil,
        description,
        usageLimit,
        userUsageLimit,
        discountPrice,
        linkServiceId,
        corporationId,
      } = getValues();
      const crCouponInput: CrCouponInput = {
        name,
        scope,
        status,
        code,
        validFrom,
        validUntil,
        description,
        usageLimit,
        userUsageLimit,
        discountPrice,
        linkServiceId,
        corporationId,
      };
      CrCoupon({ variables: { input: crCouponInput } });
    }
  };

  const tabList: ITabLink[] = [];
  const stitle: ITabTitle = { text: "쿠폰 등록" };

  useEffect(() => {
    listLinkServiceSelect();
    listCorporationSelect();
  }, []);

  return (
    <div className="bg-main bg-opacity-50 w-full h-full min-h-screen">
      <div className="w-full mx-auto h-full min-h-screen bg-gray-100">
        <main id="main">
          <div className="grid grid-cols-[200px_1fr] max-w-full">
            <AsideAdminComponent />
            <div className="mypages bg-gray-100 w-full min-w-[1200px] overflow-hidden">
              <div className="orderWrap">
                <div className="h-fix-content relative">
                  <div className={`w-full h-full px-10 py-8`}>
                    <ComponentTabLink
                      tabs={tabList}
                      stitle={stitle}
                      type={PageType.Create}
                    />
                    <div className="shadow-lg w-full h-fix-content bg-white">
                      <form onSubmit={handleSubmit(onSubmit)} id="create">
                        <div className="pl-9 pr-11 py-8 space-y-4">
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              발행 범위
                            </p>
                            <div className="grid grid-cols-4">
                              {CouponScopeOption.map(
                                (couponScope: CouponScope, index: number) => (
                                  <div
                                    className="flex items-center"
                                    key={`couponScope-option-${index}`}
                                  >
                                    <input
                                      {...register("scope", {
                                        required: `발행 범위를 선택해주세요`,
                                        onChange: (e) => {
                                          setScopeOption(e.target.value);
                                        },
                                      })}
                                      className="border border-[#F0F0F4] rounded-lg py-1 px-2 w-full text-base"
                                      type="radio"
                                      name="scope"
                                      defaultChecked={index === 0}
                                      id={couponScope.label}
                                      value={couponScope.value}
                                    />
                                    <label
                                      htmlFor={couponScope.label}
                                      className="px-2"
                                    >
                                      {couponScope.label}
                                    </label>
                                  </div>
                                )
                              )}
                            </div>
                            {/* <select
                                {...register(`status`, {})}
                                className="border border-[#F0F0F4] rounded-lg py-1 px-2 w-full text-base"
                              >
                                {Object(GoodStatusOption).map(
                                  (
                                    goodStatus: GoodStatusOptionType,
                                    index: number
                                  ) => (
                                    <option
                                      key={`goodStatus-option-${index}`}
                                      value={goodStatus.value}
                                      selected={index === 1}
                                      disabled={index === 0}
                                    >
                                      {goodStatus.label}
                                    </option>
                                  )
                                )}
                              </select> */}
                          </div>

                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              사용처
                            </p>
                            <Controller
                              name="linkServiceId"
                              control={control}
                              rules={{
                                required:
                                  scopeOption === "LINK_SERVICE"
                                    ? "쿠폰을 발급할 곳을 선택해주세요"
                                    : false,
                              }}
                              render={({
                                field: { onChange, value, name },
                              }) => {
                                const options =
                                  linkservice?.listLinkServiceSelect.linkservice?.map(
                                    (service) => ({
                                      value: service.id,
                                      label: service.name,
                                    })
                                  ) || [];

                                const selectedValue =
                                  options.find(
                                    (option) => option.value === value
                                  ) || null;

                                return (
                                  <Select
                                    name={name}
                                    options={options}
                                    value={selectedValue}
                                    onChange={(selectedOption) => {
                                      onChange(selectedOption?.value || null);
                                    }}
                                    placeholder="쿠폰을 발급할 곳을 선택해주세요"
                                    className={`w-full rounded-lg h-10 ${
                                      scopeOption === "LINK_SERVICE"
                                        ? "block"
                                        : "hidden"
                                    }`}
                                    isDisabled={scopeOption !== "LINK_SERVICE"}
                                    isClearable
                                  />
                                );
                              }}
                            />
                            <Controller
                              name="corporationId"
                              control={control}
                              rules={{
                                required:
                                  scopeOption === "CORPORATION"
                                    ? "쿠폰을 발급할 곳을 선택해주세요"
                                    : false,
                              }}
                              render={({
                                field: { onChange, value, name },
                              }) => {
                                const options =
                                  corporationSelect?.listCorporationSelect.corporations?.map(
                                    (corporation) => ({
                                      value: corporation.id,
                                      label: corporation.name,
                                    })
                                  ) || [];
                                const selectedValue =
                                  options.find(
                                    (option) => option.value === value
                                  ) || null;
                                return (
                                  <Select
                                    name={name}
                                    options={options}
                                    value={selectedValue}
                                    onChange={(selectedOption) => {
                                      onChange(selectedOption?.value || null);
                                    }}
                                    placeholder="쿠폰을 발급할 곳을 선택해주세요"
                                    className={`w-full rounded-lg h-10 ${
                                      scopeOption === "CORPORATION"
                                        ? "block"
                                        : "hidden"
                                    }`}
                                    isDisabled={scopeOption !== "CORPORATION"}
                                    isClearable
                                  />
                                );
                              }}
                            />

                            {errors.linkServiceId?.message &&
                              scopeOption === "LINK_SERVICE" && (
                                <FormError2
                                  errorMessage={errors.linkServiceId.message}
                                />
                              )}
                            {errors.corporationId?.message &&
                              scopeOption === "CORPORATION" && (
                                <FormError2
                                  errorMessage={errors.corporationId.message}
                                />
                              )}
                          </div>
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              쿠폰 이름
                            </p>
                            <input
                              {...register("name", {
                                required: `쿠폰 이름을 입력해주세요`,
                              })}
                              type="text"
                              className="border w-full  border-[#F0F0F4] text-base rounded-lg py-1 px-4 h-10"
                            />
                            {errors.name?.message && (
                              <FormError2 errorMessage={errors.name.message} />
                            )}
                            {!errors.name?.message && (
                              <p className="text-sm text-gray-400 ">
                                사용자에게 보이는 쿠폰 이름입니다.
                              </p>
                            )}
                          </div>
                          <div className="grid grid-cols-2 gap-x-12">
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                할인 가격
                              </p>
                              <input
                                {...register("discountPrice", {
                                  valueAsNumber: true,
                                  required: `할인 가격을 입력해주세요`,
                                })}
                                type="number"
                                defaultValue={0}
                                className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                              />
                              {errors.discountPrice?.message && (
                                <FormError2
                                  errorMessage={errors.discountPrice.message}
                                />
                              )}
                            </div>
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                발행 매수
                              </p>
                              <input
                                {...register("usageLimit", {
                                  min: 0,
                                  max: 1000000,
                                  valueAsNumber: true,
                                })}
                                type="number"
                                defaultValue={0}
                                className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                              />
                              <p className="text-sm text-gray-500">
                                0개는 발행의 한도가 없는 것 입니다.
                              </p>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-x-12">
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                발행 기간
                              </p>
                              <div className="flex flex-wrap items-center space-y-4">
                                <div className="flex justify-center flex-col w-full">
                                  <div className="flex items-center w-full">
                                    <input
                                      {...register("validFrom", {
                                        required: `발행 시작 일자를 입력해주세요`,
                                      })}
                                      type="datetime-local"
                                      placeholder="발행 시작 일자"
                                      className="border flex-1 h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                                    />
                                    <span className="w-10 text-center inline-block">
                                      부터
                                    </span>
                                  </div>
                                  {errors.validFrom?.message && (
                                    <FormError2
                                      errorMessage={errors.validFrom.message}
                                    />
                                  )}
                                </div>
                                <div className="flex flex-col justify-center  w-full">
                                  <div className="flex items-center w-full">
                                    <input
                                      {...register("validUntil", {
                                        required: `발행 종료 일자를 입력해주세요`,
                                      })}
                                      type="datetime-local"
                                      placeholder="발행 종료 일자"
                                      className="border flex-1 h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                                    />
                                    <span className="w-10 text-center inline-block">
                                      까지
                                    </span>
                                  </div>
                                  {errors.validUntil?.message && (
                                    <FormError2
                                      errorMessage={errors.validUntil.message}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                사용 상태
                              </p>
                              <div className="flex flex-wrap gap-x-8">
                                {CouponStatusOption.map(
                                  (
                                    couponStatus: CouponStatus,
                                    index: number
                                  ) => (
                                    <div
                                      className=""
                                      key={`goodStatus-option-${index}`}
                                    >
                                      <input
                                        {...register("status", {
                                          required: `사용 상태를 선택해주세요`,
                                        })}
                                        className="border border-[#F0F0F4] rounded-lg py-1 px-2 w-full text-base"
                                        type="radio"
                                        name="status"
                                        defaultChecked={index === 0}
                                        id={couponStatus.label}
                                        value={couponStatus.value}
                                      />
                                      <label
                                        htmlFor={couponStatus.label}
                                        className="px-2"
                                      >
                                        {couponStatus.label}
                                      </label>
                                    </div>
                                  )
                                )}
                              </div>
                              {errors.status?.message && (
                                <FormError2
                                  errorMessage={errors.status.message}
                                />
                              )}
                            </div>
                          </div>
                          <div className="flex flex-wrap justify-center pt-6">
                            <Button
                              className={`w-[240px] h-[40px] bg-[#3D3E49] text-white rounded-lg`}
                              canClick={true}
                              actionText={`등록`}
                              loading={loading}
                              color={"text-white"}
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
